<template>
  <div id="wait-complete-material">
    <el-dialog
      title
      top="50%"
      v-model="showModal"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="print-modal"
      :show-close="false"
    >

      <div class="close" @click="close" v-if="showModal">
        <img src="../../assets/imgs/product/icon-close.png" />
      </div>

      <div class="print-pages">
        <div class="print-page" ref="printpage">
          <div class="product-header">
            <div class="product-header-bg"></div>
            <div class="product-title-box">
              <div class="product-title">
                {{ orderData.product_name }}
              </div>
            </div>
            <div class="product-info-list">
              <div class="print-product-info-item">
                <div class="item-label">订单号</div>
                <div class="item-value">{{orderData.user_order_id}}</div>
              </div>
              <div class="print-product-info-item">
                <div class="item-label">联系人姓名</div>
                <div class="item-value">{{orderData.contact_name}}</div>
              </div>
              <div class="print-product-info-item">
                <div class="item-label">预计出行</div>
                <div class="item-value">{{orderData.depart_date}}</div>
              </div>
              <div class="print-product-info-item">
                <div class="item-label">电话号码</div>
                <div class="item-value">{{orderData.contact_number}}</div>
              </div>
              <div class="print-product-info-item">
                <div class="item-label">待修改</div>
                <div class="item-value">{{unqualifiedMaterial.length}}人</div>
              </div>
            </div>
            <div class="flag-box">
              <div class="flag-img" :style="{background: `url(${orderData.national_flag_img}) no-repeat center / cover`}"></div>
            </div>
          </div>
          <div class="product-body">
            <div class="applicant-section" v-for="(applicant, index) in unqualifiedMaterial" :key="index">
              <div class="section-header">
                <div class="header-line-1"></div>
                <div class="header-line-2"></div>
                <div class="section-title">{{applicant.applicant_name}}</div>
                <div class="tips">{{applicant.identity}}</div>
              </div>
              <div class="section-content">
                <div class="material-item" v-if="applicant.unqualifiedElecMaterial && applicant.unqualifiedElecMaterial.length > 0">
                  <div class="material-title-box">
                    <div class="material-title">电子资料</div>
                  </div>
                  <div class="material-table-box">
                    <table class="material-table">
                      <thead>
                        <tr>
                          <th>资料名称</th>
                          <th>资料要求</th>
                          <th>预审不合格原因</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(em, index) in applicant.unqualifiedElecMaterial" :key="index">
                          <td class="table-name">{{em.elec_name}}</td>
                          <td class="table-attention">
                            <ul v-if="em.attentionArray.length > 0">
                              <li v-for="(a, index) in em.attentionArray" :key="index">{{a}}</li>
                            </ul>
                            <ul v-else>
                              <li><span>• </span>无资料要求</li>
                            </ul>
                          </td>

                          <!-- 申请表。只有申请表在此级有 memoArray，其它电子资料是在 upload 下才有 memoArray -->
                          <td class="table-reason" >
                            <template v-if="em.memoArray">
                              <ul v-if="em.memoArray.length > 0">
                                <li v-for="(m, index) in em.memoArray" :key="index">{{m}}</li>
                              </ul>
                            </template>
                            <template v-else>
                              <ul v-for="(u, index) in em.upload" :key="index">
                                <li v-for="(m, index) in u.memoArray" :key="index">{{m}}</li>
                              </ul>
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="material-item" v-if="applicant.unqualifiedPaperMaterial && applicant.unqualifiedPaperMaterial.length > 0">
                  <div class="material-title-box">
                    <div class="material-title">纸质资料</div>
                    <div class="material-sub-title">
                      <img class="upload-icon" src="../../assets/imgs/order-detail/icon-upload.png" alt="">
                      标记资料支持上传电子版修改
                    </div>
                  </div>
                  <div class="material-table-box">
                    <table class="material-table">
                      <thead>
                        <tr>
                          <th>资料名称</th>
                          <th>资料要求</th>
                          <th>预审不合格原因</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(em, index) in applicant.unqualifiedPaperMaterial" :key="index">
                          <!--
                            0未绑定 1绑定电子资料 2绑定申请表 3绑定签证照
                            bind 值只要不为 0，均为绑定了电子资料。
                          -->
                          <td class="table-name">{{em.paper_name}}<img class="upload-icon" src="../../assets/imgs/order-detail/icon-upload.png" alt="" v-if="em.bind"></td>
                          <td class="table-attention">
                            <ul v-if="em.attentionArray.length > 0">
                              <li v-for="(a, index) in em.attentionArray" :key="index">{{a}}</li>
                            </ul>
                            <ul v-else>
                              <li><span>• </span>无资料要求</li>
                            </ul>
                          </td>
                          <td class="table-reason">
                            <ul v-if="em.express[0].memoArray.length > 0">
                              <li v-for="(m, index) in em.express[0].memoArray" :key="index">{{m}}</li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="print-bottom" v-if="showModal">
          <div class="button">
            <div @click="downloadPDF()">下载 PDF 版</div>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { html2pdf } from '@/libs/pdf';
// import { Loading } from 'element-ui';

export default {
  name: 'waitCompleteMaterial',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    // 是否打开
    value: {
      type: Boolean,
      required: true,
      default: false,
    },

    // 订单数据
    orderData: {
      type: Object,
      required: true,
      default: {},
    },

    // 不合格的资料
    unqualifiedMaterial: {
      type: Array,
      required: true,
      default: [],
    },
  },
  data() {
    return {
      showModal: this.value, // 是否展示
    };
  },
  methods: {
    // 关闭
    close() {
      this.$emit('input', false);
    },

    // 下载 PDF
    downloadPDF() {
      const target = document.querySelector('.print-page');
      target.style.overflowY = 'visible';
      target.style.maxHeight = 'none';
      html2pdf(target, `订单${this.orderData.user_order_id}修改资料清单`).finally(() => {
        target.style.overflowY = 'auto';
        target.style.maxHeight = '';
      });
    },
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
    },
  },
};
</script>

<style lang="less" scoped>
.red{
  color: #FF6464;
}
#wait-complete-material {
  .close {
    position: absolute;
    top: 0;
    right: -86px;
    cursor: pointer;
  }
  .print-pages {
    width: 1000px;
    border-radius:2px;
    overflow: hidden;
    .print-page {
      max-height: 780px;
      overflow-y: auto;
      font-size: 14px;

      // 定义滚动条宽高及背景
      &::-webkit-scrollbar {
        width: 8px;
        background-color: #ffffff;
      }

      /*定义滚动条轨道*/
      &::-webkit-scrollbar-track {
        border-radius: 4px;
      }

      // 定义滚动条滑块
      &::-webkit-scrollbar-thumb {
        background-color: rgba(0,0,0,0.2);
        border-radius: 4px;

        &:hover {
          background-color: rgba(0,0,0,0.3);
        }
      }

    }
    .print-bottom {
      height: 96px;
      display: flex;
      align-items: center;
      background: #ffffff;
      padding: 0 24px;
      border-top: 1px solid #DEE2E6;
      .button {
        flex-grow: 1;
        display: flex;
        justify-content: flex-end;
        div {
          width: 180px;
          height: 48px;
          background: #599FFF;
          font-size:18px;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius:4px;
          margin-left: 16px;
          cursor: pointer;
        }
      }
    }
  }
}

// 兼容一下小屏设备
@media screen and (max-height: 880px) {
  #wait-complete-material .print-pages .print-page {
    max-height: 700px;
  }
}
@media screen and (max-height: 800px) {
  #wait-complete-material .print-pages .print-page {
    max-height: 630px;
  }
}
@media screen and (max-height: 720px) {
  #wait-complete-material .print-pages .print-page {
    max-height: 510px;
  }
}
@media screen and (max-height: 620px) {
  #wait-complete-material .print-pages .print-page {
    max-height: 420px;
  }
}
</style>

<style lang="less">
#wait-complete-material {
  .el-dialog__wrapper {
    background:rgba(0,0,0,0.1);
  }
  .el-dialog {
    transform: translate(-50%, -50%);
    margin: 0;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
  .print-modal {
    width: 1000px;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
  .print-bottom {
    .show-contracts {
      span.el-checkbox__label {
        color: #333333;
      }
    }
  }
  .edit-product-name-modal {
    width: 360px;
    height: 280px;
  }
}
.print-page{
  -webkit-print-color-adjust: exact;
  .product-header{
    background-color: #599FFF;
    position: relative;
    padding: 32px 16px;
    line-height: 1;
    .product-header-bg{
      width: 440px;
      height: 242px;
      background: url(../../assets/imgs/product-detail/print-masterial-bg.png) no-repeat center / 100% 100%;
      position: absolute;
      right: 0;
      top: 0;
    }
    .product-title-box{
      padding-top: 8px;
      position: relative;
      z-index: 1;
      .product-title{
        font-size: 28px;
        color: #fff;
        font-weight: 600;
        line-height: 36px;
        margin-bottom: 20px;
        .edit-title{
          margin-left: 12px;
          line-height: 36px;
          display: inline-flex;
          align-items: center;
          font-size: 20px;
          vertical-align: top;
          cursor: pointer;
          .edit-icon{
            width: 24px;
            height: 24px;
            margin-right: 4px;
          }
        }
      }
    }
    .product-info-list{
      width: 600px;
      margin-top: 40px;
      display: flex;
      flex-wrap: wrap;
      padding: 0 16px;
      .print-product-info-item{
        width: 50%;
        display: flex;
        align-items: center;
        margin-top: 21px;
        .item-label{
          color: #fff;
          font-size: 18px;
          width: 90px;
          margin-right: 16px;
          flex-shrink: 0;
        }
        .item-value{
          flex-grow: 1;
          font-size: 18px;
          line-height: 24px;
          color: #fff;
        }
      }
    }
    .flag-box{
      background:linear-gradient(180deg,rgba(255,255,255,1) 0%,rgba(245,249,255,1) 100%);
      position: absolute;
      right: 60px;
      bottom: -50px;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0;
      z-index: 10;
      .flag-img{
        width: 90px;
        height: 90px;
        border-radius: 50%;
      }
    }
  }
  .product-body{
    padding: 24px 0 0 0;
    .applicant-section{
      .section-header{
        position: relative;
        height: 40px;
        background:linear-gradient(270deg,rgba(255,255,255,1) 0%,rgba(242,247,255,1) 100%);
        color: #2F333D;
        font-size: 20px;
        display: flex;
        align-items: center;
        font-weight: 600;
        padding: 0 32px;
        .header-line-1{
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 6px;
          background-color: #599FFF;
        }
        .header-line-2{
          position: absolute;
          left: 6px;
          top: 0;
          height: 100%;
          width: 6px;
          background:#599FFF;
          opacity:0.2;
        }
        .tips{
          margin-left: 12px;
          font-size: 16px;
          color: #5F666E;
          font-weight: 400;
        }
      }
      .section-content{
        padding:  24px 32px;
        .material-item{
          margin-bottom: 32px;
          &:last-child{
            margin-bottom: 0;
          }
          .material-title-box{
            display: flex;
            align-items: center;
            .material-title{
              color: #2F333D;
              font-size: 18px;
              margin-right: 16px;
              font-weight: 600;
            }
            .material-sub-title{
              display: flex;
              align-items: center;
              color: #91999F;
              font-size: 14px;
              .upload-icon{
                width: 24px;
                height: 24px;
                margin-right: 4px;
              }
            }
          }

          .material-table-box{
            margin-top: 16px;
            width: 100%;
            .material-table{
              table-layout: fixed;
              width: 100%;
              border-collapse: collapse;
              thead{
                tr{
                  th{
                    border:1px solid #DEE2E6;
                    background: #FAFBFC;
                    height: 48px;
                    padding: 0 16px;
                    color: #2F333D;
                    font-size: 16px;
                    line-height: 22px;
                  }
                }
              }
              tbody{
                tr{
                  td{
                    border:1px solid #DEE2E6;
                    padding: 24px;
                    &.table-name{
                      color: #2F333D;
                      font-size: 18px;
                      line-height: 24px;
                      font-weight: 600;
                      .upload-icon{
                        width: 24px;
                        height: 24px;
                        margin-left: 4px;
                        line-height: 24px;
                        vertical-align: top;
                      }
                    }
                    &.table-attention{
                      color: #2F333D;
                      font-size: 16px;
                      line-height: 28px;
                    }
                    &.table-reason{
                      color: #F4455C;
                      font-size: 16px;
                      line-height: 28px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/order-detail/wait-complete-material.vue